/**
 * @owner @Appboy/billing
 */

// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isLineConsumptionResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      month: number,
      year: number,
      company: string,
      destination: string,
      billable_sends: number,
      credit_ratio: number,
      credits_used: number,
      last_updated_at: number,
    })
  ),
});
